import React from 'react'
import styled from 'styled-components'
import Navbar from '../components/Navbar'

const FeedbackPage = () => {

    return (
        <div>
            <Navbar />
            <ContentBox>FeedbackPage -</ContentBox>
        </div>
    )
}

export default FeedbackPage

const ContentBox = styled.div`
  width: 98%;
  margin-top: 70px;
  z-index: -10000000;


`